import { RouteProps } from 'react-router-dom';

const headers: RouteProps[] = [
	{
		path: `*`,
		element: null,
	},
];

export default headers;
